/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
  sectionColor?: string;
};

const WarningContainer = styled('div')<Theme>(({ theme, sectionColor }) => ({
  backgroundColor: sectionColor
    ? `${sectionColor}55`
    : `${theme.colors.error.main}55`,
  padding: theme.spacing(3),
  color: theme.colors.grey.dark,
  fontSize: theme.typography.body2.fontSize,
  borderTopLeftRadius: '4px',
  borderTopRightRadius: '4px',
}));

const Rejection = styled(Typography)<Theme>(({ theme }) => ({
  marginTop: theme.spacing(4),
  wordBreak: 'break-word',
}));

export default function DeclarationCommentSection({
  comment,
  title,
  infoText,
  sectionColor,
}: {
  comment: string;
  title: string;
  infoText?: string;
  sectionColor: string;
}): JSX.Element {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();

  return (
    <WarningContainer sectionColor={sectionColor}>
      <Typography css={{ fontWeight: theme.typography.fontWeightBold }}>
        {title}
      </Typography>
      {infoText}
      <Rejection>{comment}</Rejection>
    </WarningContainer>
  );
}
